import React, { useEffect, useState } from "react";
import { AudioLines } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (n) => Number(n || 0).toLocaleString();

export default function VoiceUsageCard() {
  const [u, setU] = useState(null);

  useEffect(() => {
    api.get("/admin/voice/usage").then((r) => setU(r.data)).catch(() => {});
  }, []);

  if (!u) return null;
  const pct = u.limit ? Math.min(100, (u.used / u.limit) * 100) : 0;

  return (
    <section className="border border-obsidian-600 p-6 mb-10" data-testid="voice-usage-card">
      <div className="flex items-center gap-2 mb-1">
        <AudioLines className="h-4 w-4 text-terracotta" />
        <h2 className="font-serif text-2xl text-bone-100">ElevenLabs voice</h2>
      </div>
      {!u.connected ? (
        <p className="font-sans text-sm text-bone-400" data-testid="voice-usage-offline">Couldn't reach ElevenLabs right now.</p>
      ) : (
        <>
          <p className="font-sans text-sm text-bone-400 mb-4">
            {u.tier} plan · status <span className={u.ok ? "text-bone-200" : "text-terracotta"} data-testid="voice-usage-status">{u.status}</span>
            {u.resets_at && <> · resets {new Date(u.resets_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</>}
          </p>
          {u.open_invoice_cents > 0 && (
            <p className="mb-4 border border-terracotta/60 bg-terracotta/10 p-3 font-sans text-sm text-bone-100" data-testid="voice-usage-invoice">
              Unpaid ElevenLabs invoice: ${(u.open_invoice_cents / 100).toFixed(2)}. Voice generation is paused until it's paid at elevenlabs.io → My Account → Subscription.
            </p>
          )}
          <div className="h-2 bg-obsidian-800 mb-2"><div className="h-full bg-terracotta" style={{ width: `${pct}%` }} /></div>
          <p className="font-sans text-sm text-bone-300 mb-4">
            <span data-testid="voice-usage-used">{fmt(u.used)}</span> of {fmt(u.limit)} characters used ·{" "}
            <span data-testid="voice-usage-left">{fmt(u.left)}</span> left this month
          </p>
        </>
      )}
      <p className="font-sans text-xs uppercase tracking-[0.2em] text-bone-500" data-testid="voice-usage-cache">
        Uncle Danny narrator · {fmt(u.cache.lines)} lines saved · {fmt(u.cache.reuses)} replays served free from saved audio
      </p>
    </section>
  );
}
